import { Modal, PrimaryButton, PrimaryCardButton, RadioButtonGroup } from '@cb/apricot-react';
import { Grid, LinearProgress } from '@mui/material';
import { FC, useState } from 'react';

import { RadioButton, Typography } from 'src/components';
import { authorizationLevelOptions } from 'src/constants';

interface AuthorizationLevelModalProps {
  isOpen?: boolean;
  isLoading?: boolean;
  onClose: VoidFunction;
  onSubmit: (authorization: string) => void;
}

const AuthorizationLevelModal: FC<AuthorizationLevelModalProps> = ({ isOpen, isLoading, onClose, onSubmit }) => {
  const [authorization, setAuthorization] = useState('1');

  const handleChangeAuthorization = (value: string) => {
    setAuthorization(value);
  };

  const handleSubmit = () => {
    onSubmit(authorization);
  };

  return (
    // @ts-ignore
    <Modal
      title="Choose Authorization Level"
      actions={[
        <PrimaryButton key="submit" onClick={handleSubmit}>
          Submit
        </PrimaryButton>,
        <PrimaryCardButton key="close" onClick={onClose}>
          Close
        </PrimaryCardButton>,
      ]}
      closeButton={false}
      open={isOpen}
      onClose={onClose}
      withHeader>
      {isLoading && <LinearProgress />}

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="body2">
            <b>Level 1 Authorization: </b>
            Required for schools to <b>receive</b> their students’ Pre-AP, AP Exam, PSAT, SAT and other College Board
            test scores. Schools cannot administer AP, PSAT, SAT or other College Board exams, but can participate in
            the AP Course Audit, and in the Pre-AP program.
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2">
            <b>Level 2 Authorization: </b>
            Required for schools to <b>receive</b> scores as well as <b>administer</b> AP Exams and PSAT-related
            assessments and to apply to become a SAT Test Center.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {/* @ts-ignore */}
          <RadioButtonGroup
            name={'authorization'}
            onChange={handleChangeAuthorization}
            value={authorization}
            vertical
            vSpacing="16">
            {authorizationLevelOptions.map((option) => (
              <RadioButton key={option.value} label={option.label} value={option.value} />
            ))}
          </RadioButtonGroup>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default AuthorizationLevelModal;
